// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicOnboardingPersonalSuccess } from "./plasmic/collect_wise_draft/PlasmicOnboardingPersonalSuccess";
import LoadingSpinner from "./LoadingSpinner";
import {useNavigate} from "react-router-dom"
import {useAuth} from "../contexts/AuthContext"

function OnboardingPersonalSuccess_(props, ref) {

  const {onboardModal, setOnboardModal} = useAuth()
  const navigate = useNavigate()
  

  return onboardModal ? <LoadingSpinner/> : <PlasmicOnboardingPersonalSuccess root={{ ref }} {...props} continueButton={{onClick: () => navigate("/")}}/>;
}

const OnboardingPersonalSuccess = React.forwardRef(OnboardingPersonalSuccess_);

export default OnboardingPersonalSuccess;
